
























import { Component, Prop, Emit, Vue } from 'vue-property-decorator';

@Component
export default class ChangeFieldButton extends Vue {
  @Prop({ default: false })
  private opened!: boolean;
  @Prop({ default: '' })
  private moreLink!: string;
  @Prop({ default: '' })
  private LessLink!: string;
  @Prop({ default: false })
  private disabled!: boolean;
  @Emit('clickButton')
  clickButton(type: string) {
    return type;
  }
}
